import React, { Component } from "react";
import { Accessor, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ZRepeator extends Component {

  static propTypes = {
    onRefresh: PropsType.func,
    refreshTime: PropsType.number,
  }

  static defaultProps = {
    refreshTime: 60000
  }

  constructor(){
    super();
    this.state = {
      
    };
  }

  componentDidMount(){
    this._active();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ZRepeator.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(ZRepeator.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _active = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this._refresh, SysConfig.RefreshDelay * 1000);
  }

  _refresh = () => {
    let {onRefresh} = this.props;
    clearTimeout(this.timeout);
    this.lastUpdated = ZTime.Now().toISOString();
    onRefresh?.();
    this.timeout = setTimeout(this._refresh, SysConfig.RefreshTime * 1000);
  }

  render(){
    return (
      <div/>
    );
  }

}

export default ZRepeator;
